import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addwpsgroup',
  templateUrl: './addwpsgroup.component.html',
  styleUrls: ['./addwpsgroup.component.css']
})
export class AddwpsgroupComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;
  
  formname:String="WpsGroup"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;
//Edit Get Values
wpsgroupColl:any=[];
wpsgroupBO:any={};

wpsgroupid:number=0

wpsgroupform=new FormGroup({
  wpsgroupid:new FormControl(0),          
  wpsgroupname:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.wpsgroupid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.wpsgroupform.reset();
       this.fnInitializeFormGroup(); 

       if(this.wpsgroupid>0){
         this.fngetWpsGroup();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.wpsgroupid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}

fnInitializeFormGroup(){
   this.wpsgroupform.setValue({
    wpsgroupid:0,    
    wpsgroupname:'',
     inactive:false              
   })
}

//Get 
fngetWpsGroup() { 
  if (this.showProgress) {
    return;
  }       
     var data = {
       'wpsgroupid':this.wpsgroupid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getWpsGroup(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){  
          this.fnHideProgress();

           this.wpsgroupColl=res.json().result;
           var editdata = this.wpsgroupColl[0];        
           this.fnEditMode(editdata);
           this.wpsgroupBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{     
      this.fnHideProgress();
     
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{ if (this.saveloading) {
    return;
  }

     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.wpsgroupform.valid){ this.saveloading = true;
         //Check
         var data = {
               'wpsgroupid': this.wpsgroupid,                      
               'wpsgroupname':this.wpsgroupform.get('wpsgroupname').value, 
               'inactive':this.wpsgroupform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckWpsGroup(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.wpsgroupform.get('wpsgroupid').value>0){
                       //Update 
                       this.fnSetWpsGroup(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertWpsGroup(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;

                       this.wpsgroupform.controls['wpsgroupname'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;

               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;

             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;

     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertWpsGroup(data){    
 
   this.appService.fnInsertWpsGroup(data).subscribe(
     (res)=>{ this.saveloading = false;

       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new wpsgroup has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.wpsgroupname);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;

       this.toastr.error('Error', err);
     });

}

//Set
fnSetWpsGroup(data){    

this.appService.fnSetWpsGroup(data).subscribe(
 (res)=>{ this.saveloading = false;

   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The wpsgroup has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.wpsgroupid,data.wpsgroupname);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;

   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/WpsGroup']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.wpsgroupform.setValue({ 
  wpsgroupid:deptBO.wpsgroupid,     
  wpsgroupname:deptBO.wpsgroupname,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}

fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}








}
